module.exports = __webpack_public_path__ + "static/media/ElephantInset.092ed742.svg";